import React, { useState } from 'react';
import { Stack, TextInput, PasswordInput, Button, Alert } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconAlertCircle } from '@tabler/icons-react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';

export default function EmailSignInForm({ onSuccess }) {
  const [error, setError] = useState('');
  const form = useForm({
    initialValues: { email: '', password: '' },
    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
      password: (value) => (value.length >= 6 ? null : 'Password must be at least 6 characters'),
    },
  });

  const handleSubmit = async (values) => {
    setError('');
    try {
      await signInWithEmailAndPassword(auth, values.email, values.password);
      onSuccess?.();
    } catch (e) {
      setError('Invalid credentials');
    }
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack>
        {error && (
          <Alert icon={<IconAlertCircle size={16} />} title="Authentication error" color="red">
            {error}
          </Alert>
        )}
        <TextInput required label="Email" placeholder="you@example.com" {...form.getInputProps('email')} />
        <PasswordInput required label="Password" placeholder="Your password" {...form.getInputProps('password')} />
        <Button type="submit">Sign in</Button>
      </Stack>
    </form>
  );
}

